enum PaymentMethods {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice_on_actuals',
  PURCHASE_ORDER = 'purchase_order',
}

export { PaymentMethods }
